import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";

import { DepositBonusComponent } from "./deposit-bonus/deposit-bonus.component";
import { DepositBonusesComponent } from "./deposit-bonuses.component";

const DIRECTIVES: any[] = [DepositBonusesComponent, DepositBonusComponent];

const MAT_MODULES: any[] = [MatButtonModule, MatCardModule, MatExpansionModule];

@NgModule({
	imports: [MAT_MODULES, CommonModule, GlobalModule, CoreContentModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class DepositBonusesModule {}
